// 组件有3种情况，编辑页、预览弹窗、实际使用、查看（只读）
export const formStates = {
  editing: 'editing',
  previewing: 'previewing',
  using: 'using',
  view: 'viewing'
}

// 1面试评价表，2面试满意度问卷，3考核评价表
export const formTypes = {
  interviewEvaluation: 1,
  interviewSatisfaction: 2,
  performanceEvaluation: 3,
  recommendedReport: 4
}

export const sceneMap = {
  experienced: '1694193362399191041',
  campus: '1694193416753176577'
}

export const sceneNameMap = {
  '1694193362399191041': '社会招聘',
  '1694193416753176577': '校园招聘'
}

export const formItemTypeMap = {
  singleChoice: 'singleChoice',
  multiChoice: 'multiChoice',
  textInput: 'textInput',
  scoreInput: 'scoreInput',
  star: 'star',
  conclusionResult: 'conclusionResult',
  conclusionScore: 'conclusionScore',
  conclusionComment: 'conclusionComment'
}

export const scoreQuestionTypes = {
  singleChoice: 'singleChoice',
  scoreInput: 'scoreInput',
  star: 'star'
}

export const displayTypes = {
  vertical: 'vertical',
  horizontal: 'horizontal',
  select: 'select'
}

export const dimensionTypes = {
  normal: 'normal',
  default: 'default',
  conclusion: 'conclusion'
}

export const scoreTypes = {
  NonSystem: 1,
  systemTotal: 2,
  systemWeight: 3
}

export const scoreTypeNameMap = {
  1: '非系统计分',
  2: '系统计分-总分型',
  3: '系统计分-权重型'
}

export const statusNameMap = {
  0: '停用',
  1: '启用',
  disabled: '停用',
  enabled: '启用'
}

export const statusMap = {
  disabled: 0,
  enabled: 1
}

export const resultScoreTypes = {
  average: 'average',
  total: 'total'
}
